
const stylesHeader = {
  contentHeader (color) {
    return {
      color: '#FFFFFF',
      minHeight: 110,
      backgroundColor: color
    }
  }
};

export default stylesHeader;
